(function () {
  'use strict';

  const SECTION_PREFIX = 'shopify-section-';

  function normalizeSectionId(sectionId) {
    return sectionId.replace(new RegExp(`^${SECTION_PREFIX}`), '');
  }

  function buildSectionUrl(sectionId, targetUrl) {
    const url = new URL(targetUrl, window.location.origin);
    url.searchParams.delete('page');
    url.searchParams.set('section_id', normalizeSectionId(sectionId));
    url.searchParams.sort();
    return url;
  }

  function buildBrowserUrl(targetUrl) {
    const url = new URL(targetUrl, window.location.origin);
    url.searchParams.delete('page');
    url.searchParams.delete('section_id');
    url.searchParams.sort();
    return url;
  }

  async function renderCollectionSection(sectionId, targetUrl) {
    const sectionEl = document.getElementById(`${SECTION_PREFIX}${sectionId}`);
    const collectionRoot = sectionEl?.querySelector('[data-inga-collection]');
    const grid = sectionEl?.querySelector('[data-collection-grid]');
    const fetchUrl = buildSectionUrl(sectionId, targetUrl);

    collectionRoot?.classList.add('is-loading');
    if (grid) grid.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(fetchUrl.toString());
      if (!response.ok) throw new Error('Filter request failed');

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const nextSection =
        doc.getElementById(`${SECTION_PREFIX}${sectionId}`) || doc.querySelector('.shopify-section');

      if (nextSection && sectionEl) {
        sectionEl.replaceWith(nextSection);
      }

      const browserUrl = buildBrowserUrl(targetUrl);
      history.pushState({ collectionFilter: true }, '', browserUrl.toString());
    } finally {
      document
        .querySelector(`#${SECTION_PREFIX}${sectionId} [data-inga-collection]`)
        ?.classList.remove('is-loading');
    }
  }

  function closeAllPanels(except) {
    document.querySelectorAll('[data-filter-trigger][aria-expanded="true"]').forEach((trigger) => {
      if (except && trigger === except) return;
      trigger.setAttribute('aria-expanded', 'false');
      const panelId = trigger.getAttribute('aria-controls');
      const panel = panelId ? document.getElementById(panelId) : null;
      if (panel) panel.hidden = true;
    });
  }

  function togglePanel(trigger) {
    const panelId = trigger.getAttribute('aria-controls');
    const panel = panelId ? document.getElementById(panelId) : null;
    if (!panel) return;

    const isOpen = trigger.getAttribute('aria-expanded') === 'true';
    closeAllPanels();

    if (!isOpen) {
      trigger.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
    }
  }

  function getSectionIdFromEvent(event) {
    const root = event.target.closest('[data-inga-collection]');
    return root?.dataset.sectionId || null;
  }

  function handleDocumentClick(event) {
    const trigger = event.target.closest('[data-filter-trigger]');
    if (trigger) {
      event.preventDefault();
      togglePanel(trigger);
      return;
    }

    const filterLink = event.target.closest('[data-filter-url]');
    if (filterLink) {
      event.preventDefault();
      const sectionId = getSectionIdFromEvent(event);
      const url = filterLink.dataset.filterUrl || filterLink.getAttribute('href');
      if (sectionId && url) {
        closeAllPanels();
        renderCollectionSection(sectionId, url);
      }
      return;
    }

    if (!event.target.closest('[data-collection-filters]')) {
      closeAllPanels();
    }
  }

  function handleDocumentSubmit(event) {
    const form = event.target.closest('[data-filter-price-form]');
    if (!form) return;

    event.preventDefault();
    const sectionId = getSectionIdFromEvent(event);
    if (!sectionId) return;

    const url = new URL(window.location.href);
    url.searchParams.delete('page');

    const formData = new FormData(form);
    formData.forEach((value, key) => {
      if (value === '') {
        url.searchParams.delete(key);
      } else {
        url.searchParams.set(key, value);
      }
    });

    closeAllPanels();
    renderCollectionSection(sectionId, url.toString());
  }

  function handlePopState() {
    const section = document.querySelector('[data-inga-collection]');
    if (!section) return;
    renderCollectionSection(section.dataset.sectionId, window.location.href);
  }

  function handleKeydown(event) {
    if (event.key === 'Escape') closeAllPanels();
  }

  function init() {
    document.addEventListener('click', handleDocumentClick);
    document.addEventListener('submit', handleDocumentSubmit);
    document.addEventListener('keydown', handleKeydown);
    window.addEventListener('popstate', handlePopState);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', () => {
    closeAllPanels();
  });
})();
